import React, { useContext, useEffect, useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Login from "../../images/azadi.png";
import logo1 from "../../images/log1.png";
import logo2 from "../../images/log2.png";
import { logout } from "../../services/Api";
import Form from "react-bootstrap/Form";
// const Navbar = () => {
import Logo from "../../images/logoiiita.png";
import { Avatar, AvatarBadge, AvatarGroup } from "@chakra-ui/react";
//   const navigate = useNavigate();
// //   const { userData , setUserData} = useContext(AppContext)
//   const handleLogout = () => {
//     window.localStorage.clear();
//     // setUserData(null);
//     navigate("/");
//   }

//   return (
//       <div className="navbar">
//         <div className="name"><Link to="/" style={{color: 'inherit', textDecoration: 'none' }}>Azadi Mahotsava</Link></div>
//         <div className="links">
//           <Link className='link' to="/" style={{color: 'inherit', textDecoration: 'none' }}>Home</Link>
//           <Link className='link' to="/gallery" style={{color: 'inherit', textDecoration: 'none' }}>Gallery</Link>
//           <Link className='link' to="/uploadfiles" style={{color: 'inherit', textDecoration: 'none' }}>Upload Files</Link>
//           <Link className='link' to="/updatefiles" style={{color: 'inherit', textDecoration: 'none' }}>Update Files</Link>
//           <div className="buttons">
//             {/* { */}
//               {/* userData?.admin_name || userData?.SName ?  */}
//                   {/* <button className="logout btn" onClick={() => (handleLogout())}>Logout</button>  */}
//               :
//                 <button className="signin btn"><Link to="/login" style={{color: 'inherit', textDecoration: 'none' }}>Sign in</Link></button>

//             {/* } */}
//           </div>
//         </div>
//     </div>
//   )
// }

// export default Navbar;

const Navbar_view = () => {
  const navigate = useNavigate();
  //const { userData , setUserData} = useContext(AppContext)

  const [user, setUser] = useState(null);
  useEffect(() => {
    const data = JSON.parse(window.localStorage.getItem("user"));
    console.log(data);
    if (data) setUser(data);
  }, []);

  const handleLogout = async () => {
    
    window.localStorage.clear();
    const data = await logout();
    setUser(null);
    navigate("/");
    // window.location.reload();
    // window.location.href="/";
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <Navbar collapseOnSelect expand="lg">
      <Navbar.Brand>
        <Image
          className="logo"
          src={Logo}
          roundedCircle="true"
          fluid="true"
        ></Image>
      </Navbar.Brand>
      <Navbar.Brand>
        <Image
          className="logo"
          src={logo1}
          roundedCircle="true"
          fluid="true"
        ></Image>
      </Navbar.Brand>
      <Navbar.Brand>
        <Image
          className="logo"
          src={logo2}
          
          fluid="true"
        ></Image>
      </Navbar.Brand>
      <Navbar.Brand>
        <Nav.Link href="/">
          <Image
            className="logo"
            src={Login}
            roundedCircle="true"
            fluid="true"
          ></Image>
          
        </Nav.Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link href="/">Home</Nav.Link>
          {user?.usertype === "admin" || user?.usertype === "superadmin" ? (
            <Nav.Link href="/adminpanel">Admin Panel</Nav.Link>
          ) : (
            ""
          )}
          <Nav.Link href="/gallery">Gallery</Nav.Link>
          <Nav.Link href="/events">Events</Nav.Link>
          {/* <Nav.Link href="/gallery"></Nav.Link> */}
          {user?.uid ? (
            <>
              {/* <Nav.Link href="/uploadfiles">Upload Files</Nav.Link> */}
              <Nav.Link href="/mygallery">My Gallery</Nav.Link>
            </>
          ) : (
            <></>
          )}
        </Nav>
        <Form style={{ textAlign: "center" }}>
          {user?.uid ? (
            <>
              <div className="after-login" style={{display: "flex", gap: "1rem", alignItems: "center", justifyContent: "center"}}>
                {
                  user.usertype === "superadmin" ?
                    <Avatar
                      size="md"
                      name={user.username}
                      src=""
                    >
                      <AvatarBadge boxSize='1.25em' bg='red.500' />
                    </Avatar>
                  :
                    user.usertype === "admin" ?
                      <Avatar
                        size="md"
                        name={user.username}
                        src=""
                      >
                        <AvatarBadge boxSize='1.25em' bg='green.500' />
                      </Avatar>
                    :
                      <Avatar
                        size="md"
                        name={user.username}
                        src=""
                      />
                }
                <Button variant="primary" size="lg" onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </>
          ) : (
            <Button variant="primary" size="lg" onClick={handleLogin}>
              Login
            </Button>
          )}
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navbar_view;
